import { useEffect } from 'react';
import { Card, CardContent, Typography, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { Title, useGetList, Loading, useNotify, GetListParams } from 'react-admin';
import { MapContainer } from 'react-leaflet';
import React from 'react';

import { config, showDetails, getMapPositionForShow } from '../config.js';
import { Answer } from '../domain.js';
// import { BarChart } from '../components/charts';

import { MapRatedAnswerMarker, MapTileLayer } from '../components/maps.js';

export const Dashboard: React.FC = () => {
  const { data: configData } = useGetList<{ id: string; current_show_id: string }>(
    'config',
    { 
      pagination: { page: 1, perPage: 1 }
    }
  );
  const current_show = configData?.[0]?.current_show_id || '';
  
  // Add show filter state
  const [selectedShow, setSelectedShow] = React.useState<string>('');

  const { data, isLoading: loading, error } = useGetList<Answer>(
    'answer',
    { 
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'id', order: 'ASC' },
      filter: { show_id: selectedShow || undefined }
    }
  );

  // Add show selection handler
  const handleShowChange = (event: SelectChangeEvent<string>) => {
    setSelectedShow(event.target.value);
  };

  // set selected show to current show
  useEffect(() => {
    setSelectedShow(current_show);
  }, [current_show]);

  // Add debugging for pagination
  useEffect(() => {
    if (data) {
      console.log('Total records:', data.length);
      console.log('Pagination response:', data);
    }
  }, [data]);

  // Add debugging logs
  useEffect(() => {
    console.log('Data loading state:', loading);
    console.log('Data:', data);
    console.log('Error:', error);
  }, [loading, data, error]);

  const notify = useNotify();
  useEffect(() => {
    if (error) notify('Could not load map pins', { type: 'error' });
  }, [error, notify]);

  const answers = data ? Object.values(data) : [];

  // Map starting state
  const zoom = config.defaultMapZoom;
  const position = getMapPositionForShow(selectedShow);
  console.log("Map: ", position);
  

  // prettier-ignore
  const mapInner
  = loading ? (<Loading />)
        : error ? null
        : answers.map((answer) => <MapRatedAnswerMarker key={answer.id} answer={answer} />);

  return (
    <>
      <Card>
        <Title title={`Rider Spoke: Dashboard: All shows`} />
        <CardContent>
          <FormControl variant="outlined" style={{ minWidth: 200, marginBottom: 20 }}>
            <InputLabel>Filter by Show</InputLabel>
            <Select
              value={selectedShow}
              onChange={handleShowChange}
              label="Filter by Show"
            >
              <MenuItem key={current_show} value={current_show}>
                <em>Current Show</em>
              </MenuItem>
              {showDetails.map((show) => (
                <MenuItem key={show.show_id} value={show.show_id}>{show.show_id}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <MapContainer 
            key={`${position.lat}-${position.lng}`}
            center={position} 
            zoom={zoom} 
            style={{ height: '80vh' }}
          >
            <MapTileLayer />
            {mapInner}
          </MapContainer>
          <Typography variant="subtitle1">
            This map shows all answers colour coded by their moderation rating. <br/>
            Yellow (0) to dark red (5)
          </Typography>
        </CardContent>
      </Card>
      {/* <BarChart style={{ height: '80vh'}}/>*/}
    </>
  );
};
